module.exports = __webpack_public_path__ + "img/img21.0ed797d1.svg";